import React from 'react'
import { Link } from 'react-router-dom'

function CVReviewSection() {
    return (
        <div className='cv_reviewSection mt-3 mb-5'>
            <div className='container'>
                <div className='row m-0'>
                    <div className='col-md-8 p-0'>
                        <h3>Smart CV <span>Review</span> with <span>AI</span></h3>
                        <p>Upload your CV in PDF format and let <span>EdFura AI</span> instantly analyze, rate, and provide feedback. Get personalized insights to improve your CV and increase your chances of landing top medical jobs and scholarships.</p>
                        <Link to="/cv-review">
                         <button>Explore More</button>
                        </Link>
                    </div>
                   
                </div>
            </div>

        </div>

    )
}

export default CVReviewSection